import { useState } from "react"
import useStore from "../../../../store"
import { Widget, WidgetHeader, WidgetBody } from "../../../ui/Widget"
import { FaPhone } from "react-icons/fa6"
import { FaPlusCircle } from "react-icons/fa"
import ReusableDrawer from "../../../common/ReusableDrawer"
import PersonForm from "./PersonForm"
import phoneNumber from "../../../../utilities/phoneNumber"


export default function People({ dealerId }) {
  const { people } = useStore()
  const [isOpen, setIsOpen] = useState(false)
  const hasPhoneNumber = (person) => person.attributes['cell-phone'] !== null && person.attributes['cell-phone'] !== ''

  return(
    <Widget>
      <WidgetHeader
        title="People"
        actionIcon={
          <FaPlusCircle
            className="w-6 h-6 hover:cursor-pointer"
            onClick={() => setIsOpen(true)}
          />
        }
      />
      <WidgetBody isVisible={!!people}>
        {people?.map((person) => (
          <div
            className='flex w-full items-center border-b-2 border-grey-700
              p-2 text-grey-300 text-left lg:hover:bg-grey-700 hover:cursor-pointer'
          >
            <div
              className="flex flex-col w-1/2 md:w-2/3"
            >
              <div className="text-sm">
                {person.attributes['title']}
              </div>
              <div className="font-bold text-lg text-grey-100">
                {person.attributes['full-name-no-title']}
              </div>
              <div className="text-sm">
                {hasPhoneNumber(person) ? phoneNumber(person.attributes['cell-phone']) : 'No Phone Number'}
              </div>
            </div>

            <div className="flex justify-end w-1/2 md:w-1/3">
              {hasPhoneNumber(person) && (
                <a href={`tel:${person.attributes['cell-phone']}`} className="underline hover:cursor-pointer">
                  <FaPhone />
                </a>
              )}
            </div>
          </div>
        ))}
      </WidgetBody>
      <ReusableDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Add Person"
        placement="bottom"
      >
        <PersonForm dealerId={dealerId} onClose={() => setIsOpen(false)} />
      </ReusableDrawer>
    </Widget>
  )
}